import React, { useState } from "react";
import {
  Button,
  Dialog,
  Card,
  CardBody,
  CardFooter,
  Typography,
  Input,
} from "@material-tailwind/react";
import { Axios } from "../Axios/Axios";
import FullScreenSpinner from "../Spinner/FullScreenSpinner";
import { Notification } from "../Notification/Notification";

const axios = new Axios();

export default function DialogWithForm({ open, handleOpen, product, updateNotification }) {
  const [formData, setFormData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    company: "",
    phoneNumber: "",
    message: "",
    Product: {},
    type: "products"
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let formErrors = {};

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9+\-\s()]+$/;

    if (!formData.firstName.trim()) formErrors.firstName = "Полето за Име е задолжително.";
    if (!formData.lastName.trim()) formErrors.lastName = "Полето за Презиме е задолжително.";

    if (!formData.email.trim()) {
        formErrors.email = "Полето за Електронската пошта е задолжително.";
    } else if (!emailRegex.test(formData.email)) {
        formErrors.email = "Невалидна е-пошта.";
    }

    if (!formData.phoneNumber.trim()) {
        formErrors.phoneNumber = "Полето за Телефонски број е задолжително.";
    } else if (!phoneRegex.test(formData.phoneNumber)) {
        formErrors.phoneNumber = "Невалиден телефонски број.";
    }

    if (!formData.message.trim()) formErrors.message = "Полето за Порака е задолжително.";

    
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setLoading(true);

    formData.Product = {
      id: product.id,
      name: product.name,
      image_url: product.image_url,
      tags: product.tags,
      sub_category: product.sub_category,
      category: product.category
    };

    try {
      const response = await axios.post('api/home/send-mail', formData);
      if (response.status === 200) {
        updateNotification('Електронската поштата е успешно испратена!', 'success');
      } else {
        updateNotification('Електронската пошта не е успешно испратена. Ве молиме пробајте подоцна.', 'error');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      updateNotification('Електронската пошта не е успешно испратена. Ве молиме пробајте подоцна.', 'error');
    } finally {
        setFormData({
            email: '',
            firstName: '',
            lastName: '',
            company: '',
            phoneNumber: '',
            message: '',
            Product: {},
            type: "products"
          });
      setLoading(false);
    }

    handleOpen();
  };

  return (
    <Dialog
      size="xl"
      open={open}
      handler={handleOpen}
      className="bg-transparent shadow-none"
      animate={{
        mount: { scale: 1, y: 0 },
        unmount: { scale: 0.9, y: -100 },
      }}
    >
      <Card className="mx-auto w-full max-w-7xl sm:max-w-4xl md:max-w-5xl lg:max-w-6xl">
        <CardBody className="flex flex-col sm:flex-row gap-8 overflow-auto max-h-[80vh]">
          <div className="sm:w-1/2 w-full mb-4 sm:mb-0">
            {/* Left side: Product details */}
            <Typography variant="h4" color="blue-gray" className="mb-2">
              {product.name}
            </Typography>
            <img
              src={`https://samsung-climatesolutions.com/${product.image_url}`}
              alt={`${product.name}`}
              className="w-full h-64 object-contain mb-4"
            />
            <Typography variant="paragraph" color="gray" className="mb-4">
              <strong>Категорија:</strong> {product.category} <br />
              <strong>Подкатегорија:</strong> {product.sub_category}
            </Typography>
            <Typography variant="paragraph" color="gray" className="mb-4">
              <strong>Капацитет:</strong> {product.capacities}
            </Typography>
          </div>

          <div className="sm:w-1/2 w-full">
            {/* Right side: Input fields */}
            <Typography variant="h6" className="mt-4">Електронска пошта</Typography>
            <Input
              label="Е-пошта"
              size="lg"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <span className="text-red-600 text-sm">{errors.email}</span>}

            <div className="flex flex-col lg:flex-row lg:space-x-2 mt-4">
              <div className="w-full">
                <Typography variant="h6">Име</Typography>
                <Input
                  label="Име"
                  size="lg"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                />
                {errors.firstName && <span className="text-red-600 text-sm">{errors.firstName}</span>}
              </div>
              <div className="w-full mt-4 md:mt-0">
                <Typography variant="h6">Презиме</Typography>
                <Input
                  label="Презиме"
                  size="lg"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                />
                {errors.lastName && <span className="text-red-600 text-sm">{errors.lastName}</span>}
              </div>
            </div>
            <Typography variant="h6" className="mt-4">Телефонски број</Typography>
            <Input
              label="Телефонски број"
              size="lg"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
            />
            {errors.phoneNumber && <span className="text-red-600 text-sm">{errors.phoneNumber}</span>}

            <Typography variant="h6" className="mt-4">Фирма</Typography>
            <Input
              label="Фирма"
              size="lg"
              name="company"
              value={formData.company}
              onChange={handleChange}
            />

            <Typography variant="h6" className="mt-4">Порака</Typography>
            <Input
              label="Порака"
              size="lg"
              name="message"
              value={formData.message}
              onChange={handleChange}
            />
            {errors.message && <span className="text-red-600 text-sm">{errors.message}</span>}
          </div>
        </CardBody>
        <CardFooter className="pt-0">
          <Button variant="gradient" onClick={handleSubmit} fullWidth>
            Испрати
          </Button>
        </CardFooter>
      </Card>
      <FullScreenSpinner display={loading} />
    </Dialog>
  );
}
